import React from 'react';
import '../core/filters.scss';
import { useDispatch } from 'react-redux';
import { addMightyFitFilter, removeMightyFitFilter } from '../core/filterSlice';

interface Props {
    searchText: string;
    setSearchText: (searchText: string) => void;
}

export default function SearchFilter({ searchText, setSearchText }: Props) {
    const dispatch = useDispatch();

    const handleSearch = async () => {
        dispatch(removeMightyFitFilter((filter: string) => filter.startsWith('search_text=')));

        const trimmedText = searchText.trim();
        if (trimmedText) {
            dispatch(addMightyFitFilter(`search_text=${trimmedText}`));
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newText = e.target.value;
        setSearchText(newText);
        if (newText.trim() === '') {
            dispatch(removeMightyFitFilter((filter: string) => filter.startsWith('search_text=')));
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    };

    const handleBlur = () => {
        if (searchText.trim()) {
            handleSearch();
        }
    };

    return (
        <div className="form-wrap mt-2">
            <input
                type="text"
                name="search_text"
                placeholder="Search..."
                value={searchText}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
            />
            <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handleSearch}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
            >
                <path
                    d="M8.625 16.25C12.56 16.25 15.75 13.06 15.75 9.125C15.75 5.18997 12.56 2 8.625 2C4.68997 2 1.5 5.18997 1.5 9.125C1.5 13.06 4.68997 16.25 8.625 16.25Z"
                    stroke="#707070"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5 17L15 15.5"
                    stroke="#707070"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
}